import { useState, useEffect } from 'react';
import {
  isApiCurrentlyDisconnected,
  onApiDisconnectChange,
} from '../lib/kiosk-stability';

/**
 * Hook for kiosk reconnect state
 *
 * Returns whether the app is in kiosk (tablet display) mode and whether the
 * API is disconnected. When disconnected, a reconnecting overlay should be shown.
 * The page will automatically reload when the API comes back.
 *
 * isKiosk is always true in production — this app is a dedicated tablet display.
 * In dev it is false so the reconnect overlay doesn't render during development.
 */
export function useKioskReconnect(): {
  isKiosk: boolean;
  isDisconnected: boolean;
} {
  const [isKiosk] = useState(() => import.meta.env.PROD);
  const [isDisconnected, setIsDisconnected] = useState(() => isApiCurrentlyDisconnected());

  useEffect(() => {
    const unsubscribe = onApiDisconnectChange(setIsDisconnected);
    return unsubscribe;
  }, []);

  return { isKiosk, isDisconnected };
}
